import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as GlobalFooterAPI from "@/api/global-footer";
import { CommonResponse, isSuccess } from "@/api/response";
import { SortRequest } from "@/api/global-footer/request";

const MODULE_NAME = "global-footer/modify";

/**
 * グローバルフッター情報登録更新APIのレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Modify extends VuexModule {
  // state
  commonResponse: CommonResponse = {} as CommonResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.commonResponse);
  }

  get getMessage() {
    return this.commonResponse.message;
  }

  // MutationActions
  @MutationAction
  async sort(sortRequest: SortRequest) {
    const commonResponse = await GlobalFooterAPI.sort(sortRequest);
    return {
      commonResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      commonResponse: {} as CommonResponse
    };
  }
}

export default getModule(Modify);
